import { useContext } from 'react';
import { ProdutoContext } from '../ProdutoContext';
import { ProdutoContextData } from '../types/context';

export const useProduto = (): ProdutoContextData => {
  return useContext(ProdutoContext);
};
